import defaultsDeep from "lodash/defaultsDeep"

const DEF_OPTS = {
    "base_url": "",
    "api_url": "/api",
};

const OPTS = defaultsDeep({}, window.SEARCH_OPTIONS, DEF_OPTS);

OPTS.mode_multi = OPTS.archives.length > 1;
OPTS.mode_single = OPTS.archives.length === 1;

export default OPTS;